import { colors } from "../styles";
import shuttle from "../images/voo.svg";
import shuttle2 from "../images/voo2.svg";
import shuttle3 from "../images/voo4.svg";
import shuttleWhite from "../images/voo3.svg";
import shuttleBlack from "../images/voo4.svg";

export default class ColorService {
  static backgroundColor(status) {
    switch (status) {
      case "Em andamento":
        return colors.blue[200];
      case "Agendado":
        return colors.orange[300];
      case "Programado":
        return colors.orange[300];
      case "Confirmado":
        return colors.green[500];
      case "Autorizado":
        return colors.lighter;
      case "Cancelado":
        return colors.danger;
      case "Alterado":
        return colors.red500;
      case "Finalizado":
        return colors.gray;
      case "Suspenso":
        return colors.purple.main;
      default:
        return colors.gray;
    }
  }
  static contrastColor(status) {
    switch (status) {
      case "Em andamento":
        return colors.blue.contrastText;
      case "Agendado":
        return colors.orange.contrastText;
      case "Programado":
        return colors.orange.contrastText;
      case "Confirmado":
        return colors.green.contrastTextLight;
      case "Autorizado":
        return colors.green.contrastText;
      case "Cancelado":
        return colors.white;
      case "Alterado":
        return colors.white;
      case "Finalizado":
        return colors.white;
      case "Suspenso":
        return colors.white;
      default:
        return colors.white;
    }
  }

  static image(status) {
    switch (status) {
      case "Em andamento":
        return shuttle;
      case "Agendado":
        return shuttle3;
      case "Programado":
        return shuttle3;
      case "Confirmado":
        return shuttle2;
      case "Autorizado":
        return shuttle3;
      case "Cancelado":
        return shuttle2;
      case "Alterado":
        return shuttle2;
      case "Finalizado":
        return shuttle2;
      case "Suspenso":
        return shuttle2;
      default:
        return shuttle2;
    }
  }

  static imageDetails(status) {
    switch (status) {
      case "Em andamento":
        return shuttleBlack;
      case "Agendado":
        return shuttleBlack;
      case "Programado":
        return shuttleBlack;
      case "Confirmado":
        return shuttleWhite;
      case "Autorizado":
        return shuttleBlack;
      case "Cancelado":
        return shuttleWhite;
      case "Alterado":
        return shuttleWhite;
      case "Finalizado":
        return shuttleWhite;
      case "Suspenso":
        return shuttleWhite;
      default:
        return shuttleWhite;
    }
  }
}



// WEBPACK FOOTER //
// ./src/tools/ColorsService.js